import * as React from "react";
import {cx} from "emotion";

import "./textarea-5ew.scss";

import {TextareaAutosize} from "@Common/libs/react-autosize-textarea/textarea-autosize";
import {cs}               from "@Common/react/chain-services";
import {scnv}             from "@Common/react/state-change-nested-value";
import {UseState}         from "@Common/react/use-state";

export const Textarea5ew = ({editable, className=undefined, state, maxLength, placeholder=undefined, xdQaName, domRef=undefined}) => cs(
    ["typing", (_, next) => UseState({next})],
    ["doSave", ({typing}, next) => next(() => {
        scnv(state, [], () => typing.value);
        typing.onChange(null);
    })],
    ({typing, doSave}) => (
        <TextareaAutosize {...{
            className: cx("textarea-5ew", className, {active: typing.value != null}),

            style: {resize: "vertical"},

            ref: domRef?.set,
            value: typing.value ?? state.value,
            onChange: (e) => {
                if (!editable) {
                    return;
                }
                typing.onChange(e.target.value.replace(/\r?\n/g, ""));
            },
            ...!!maxLength && {
                maxLength,
            },
            disabled: !editable,

            onBlur: () => {
                if (typing.value != null) {
                    doSave();
                }
            },
            placeholder,
            "xd-qa-type": "text_field",
            "xd-qa-name": xdQaName,
        }}/>
    )
);
